module.exports = __webpack_public_path__ + "static/list-of-recommended-measures-to-improve-working-conditions-15f164cd273c1e7cf4744de14bbe37ff.jpeg";